import {isValidAcceptedDeepLink} from './deep-link'

export const COPILOT_APP_LAUNCHER_PATH = '/copilot/app/launch'
export const GITHUB_APP_LANDING_PAGE_URL = 'https://github.com/features/ai/github-app'

/**
 * @param options.origin GitHub origin hosting the launcher, such as `https://github.com`. Pages served from
 *   another host pass it because the launcher only exists on GitHub. Defaults to the current origin.
 */
export function openCopilotAppLauncher(
  target: string,
  entryPoint: string,
  {origin = ''}: {origin?: string} = {},
): void {
  if (!isValidAcceptedDeepLink(target)) throw new Error('Invalid Copilot App launch target')

  const params = new URLSearchParams({open: target, entry_point: entryPoint})
  const tab = window.open(`${origin}${COPILOT_APP_LAUNCHER_PATH}?${params}`, '_blank')
  if (!tab) throw new Error('The browser blocked the Copilot App launcher')

  // The noopener feature returns null even on success, preventing blocked-tab detection.
  tab.opener = null
}
